<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'

const apiUrlTest = 'waybill/intercept';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "客户通过此接⼝下发需要拦截的订单",
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识",},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串",},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒",},
                    ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title:"业务参数",
              value:[
                {name: "mailNo",type: "String",require: "Y",normal: "",describe: "运单号"},
                {name: "customerCode",type: "String",require: "N",normal: "",describe: "客户编码"},
                {name: "reason",type: "String",require: "N",normal: "",describe: "拦截原因"},
                {name: "applyTypeCode",type: "Integer",require: "Y",normal: "",describe: "4：退回 5：转寄"},
                {name: "receiveProvince",type: "String",require: "Y",normal: "",describe: "转寄 地址省，applyTypeCode = 5 必传"},
                // {name: "receiveProvinceId",type: "Integer",require: "N",normal: "",describe: "applyTypeCode = 5 必传，新收件地址省id"},
                {name: "receiveCity",type: "String",require: "Y",normal: "",describe: "转寄 地址市，applyTypeCode = 5 必传"},
                // {name: "receiveCityId",type: "Integer",require: "N",normal: "",describe: "applyTypeCode = 5 必传，新收件地址市id"},
                {name: "receiveDistrict",type: "String",require: "Y",normal: "",describe: "转寄 地址区，applyTypeCode = 5 必传"},
                // {name: "receiveDistrictId",type: "Integer",require: "N",normal: "",describe: "applyTypeCode = 5 必传，新收件地址区id"},
                {name: "receiveAddress",type: "String",require: "Y",normal: "",describe: "转寄 详细地址，applyTypeCode = 5 必传"},
                {name: "receiveUsername",type: "String",require: "Y",normal: "",describe: "转寄 收件⼈姓名，applyTypeCode = 5 必传"},
                {name: "receiveMobilPhone",type: "String",require: "N",normal: "",describe: "收件⼈⼿机（⼿机与电话⾄少有⼀项不为空）applyTypeCode = 5 必传"},
                {name: "receivePhone",type: "String",require: "N",normal: "",describe: "收件⼈电话 （⼿机与电话⾄少有⼀项不为空）applyTypeCode = 5 必传"}
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录",},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述",}
                  ]
            }
        ],
        //请求示例
        requestCode: `Header：
          apiAccount=178337126125932605
          digest=U40e5sumorgd3YgZzU61Mw==
          timestamp=1565238848921
          Body：
          bizContent= {
          "mailNo":"UT0000456908252",
          "reason":"拦截原因",
          "applyTypeCode":4,
          "receiveProvince":"上海",
          "receiveProvinceId":null,
          "receiveCity":"上海市",
          "receiveCityId":null,
          "receiveDistrict":"浦东新区",
          "receiveDistrictId":null,
          "receiveAddress":"详细地址",
          "receiveUsername":"收件⼈姓名",
          "receiveMobilPhone":"18812345678",
          "receivePhone":""
          }`,
        //返回示例
        responseCode: JSON.parse(`{
          "code": "1",
          "msg": "success"
          }`),

        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{
          "mailNo":"UT0000456908252",
          "reason":"拦截原因",
          "applyTypeCode":4,
          "receiveProvince":"上海",
          "receiveProvinceId":null,
          "receiveCity":"上海市",
          "receiveCityId":null,
          "receiveDistrict":"浦东新区",
          "receiveDistrictId":null,
          "receiveAddress":"详细地址",
          "receiveUsername":"收件⼈姓名",
          "receiveMobilPhone":"18812345678",
          "receivePhone":""
          }`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>